<ul class="nav navbar-nav ml-auto">
    <!-- Language selection -->
    <li ngbDropdown class="nav-item dropdown dropdown-language">
        <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
            <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i><span
                class="selected-language">{{ languageOptions[_translateService.currentLang].title
                }}</span></a>
        <div ngbDropdownMenu aria-labelledby="dropdown-flag">
            <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
                <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{
                languageOptions[lang].title }}
            </a>
        </div>
    </li>
    <!--/ Language selection -->
</ul>